import React from 'react';
import './arbitration-agreement.scss';

const ArbitrationAgreement = () => (
  <div className="arbitration-agreement">
    <p>
      <strong>ARBITRATION AGREEMENT</strong>
    </p>

    <p>
      <span style={{ fontWeight: 400 }}>This Arbitration Agreement (“</span>
      <span style={{ fontWeight: 400 }}>Agreement</span>
      <span style={{ fontWeight: 400 }}>”) is between Swell Energy, Inc. (“</span>
      <span style={{ fontWeight: 400 }}>Swell</span>
      <span style={{ fontWeight: 400 }}>
        ”) and the consumer interested in the purchase or lease of a home battery system and/or
        solar energy system (the “System”) from Swell (“
      </span>
      <span style={{ fontWeight: 400 }}>you</span>
      <span style={{ fontWeight: 400 }}>” and “</span>
      <span style={{ fontWeight: 400 }}>your</span>
      <span style={{ fontWeight: 400 }}>
        ”). It governs how the parties will resolve any legal claims you have against us or we have
        against you. (As used in this Agreement, “
      </span>
      <span style={{ fontWeight: 400 }}>we</span>
      <span style={{ fontWeight: 400 }}>,” “</span>
      <span style={{ fontWeight: 400 }}>us</span>
      <span style={{ fontWeight: 400 }}>,” “</span>
      <span style={{ fontWeight: 400 }}>our</span>
      <span style={{ fontWeight: 400 }}>
        ” and related terms include: (1) Swell; (2) its assignees; (3) their parents, subsidiaries
        and affiliates; and (4) the employees, directors, officers, shareholders, members and
        representatives of these entities.) This Agreement may have a substantial impact on your
        rights, including your right to a jury trial or your right to bring or participate in a
        class action against us. We have put this Agreement in question and answer form to make it
        easier to understand. However, this Agreement is legally binding.{' '}
      </span>
    </p>

    <p>
      <strong>Background and Scope.</strong>
    </p>
    <table id="agreement">
      <tbody>
        <tr>
          <td>
            <p>
              <strong>Question</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Short Answer</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Further Detail</strong>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>What is arbitration?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>An alternative to a court case</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>In arbitration, a third party arbitrator (“</span>
              <span style={{ fontWeight: 400 }}>TPA</span>
              <span style={{ fontWeight: 400 }}>
                ”) decides legal claims. It is less formal than a court case.{' '}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Is it different from court and jury trials?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Yes</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Any hearing is private. There is no jury. It is usually less formal, faster and less
                expensive than a lawsuit. Pre-hearing fact finding (called “discovery”) is limited.
                Appeals are limited. Courts rarely overturn arbitration awards.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Can you reject this Agreement?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Yes, within 60 days</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                This Agreement is immediately effective. However, you can reject this Agreement. To
                do that, you must send us a personally signed notice within 60 days. You must send
                the notice in writing (and not electronically). You must send it to 1515 7th ST #49,
                Santa Monica, CA 90401 or any updated address we give you (the “
              </span>
              <span style={{ fontWeight: 400 }}>Notice Address</span>
              <span style={{ fontWeight: 400 }}>
                ”), Attn: Arbitration Rejection. You must give your name, address and the last four
                digits of your social security number. You must state that you reject the
                Arbitration Agreement. This is the only way you may reject this Agreement.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>What is this Agreement about?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>The parties' agreement to arbitrate Claims</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Unless prohibited by applicable law and unless you reject this Agreement, you and we
                agree that any party may elect to arbitrate or require arbitration of any "Claim"
                (as defined below).
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Who does the Agreement cover?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Seller and Signer, together with certain related parties </strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>This Agreement governs you and us. </span>
              <strong>
                However, this Agreement does not apply to any individual who is a member of the
                armed forces or a dependent of such member, covered by the federal Military Lending
                Act, when he or she signs an agreement providing for the credit sale of the System.
              </strong>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>What Claims does the Agreement cover?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>All Claims (except certain Claims about this Agreement)</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                This Agreement governs all “Claims” that would usually be decided in court and are
                between you and us. In this Agreement, the word “Claims” has the broadest reasonable
                meaning. It includes contract and tort claims (including intentional tort claims)
                and claims under constitutions, statutes, ordinances, rules and regulations. It
                includes all claims that directly or indirectly involve the System or any related
                agreements (“
              </span>
              <span style={{ fontWeight: 400 }}>System Agreements</span>
              <span style={{ fontWeight: 400 }}>
                ”) or our dealings or relationship with you. It includes extensions, renewals and
                refinancings of any System Agreements. It includes claims related to advertising,
                credit reports, communications, collections, privacy and customer information. It
                includes claims related to the validity in general of the System Agreements.
                However, it does not include disputes about the validity, coverage or scope of this
                Agreement or any part of this Agreement. All such disputes are for a court and not
                the TPA to decide.{' '}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Who handles the arbitration?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Usually AAA or JAMS</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Arbitrations are conducted under this Agreement and the rules of the arbitration
                company in effect at the time the arbitration is commenced. However, arbitration
                rules that conflict with this Agreement do not apply. The arbitration company will
                be either:
              </span>
            </p>

            <ul>
              <li style={{ fontWeight: 400 }}>
                <span style={{ fontWeight: 400 }}>The American Arbitration Association ("</span>
                <span style={{ fontWeight: 400 }}>AAA</span>
                <span style={{ fontWeight: 400 }}>
                  "), 1633 Broadway, 10th Floor, New York, NY 10019, www.adr.org;
                </span>
              </li>
              <li style={{ fontWeight: 400 }}>
                <span style={{ fontWeight: 400 }}>
                  JAMS, 620 Eighth Avenue, 34th Floor, New York, NY 10018,{' '}
                </span>
                <a href="http://www.jamsadr.org">
                  <span style={{ fontWeight: 400 }}>www.jamsadr.org</span>
                </a>
                <span style={{ fontWeight: 400 }}>; or</span>
              </li>
              <li style={{ fontWeight: 400 }}>
                <span style={{ fontWeight: 400 }}>
                  Any other company picked by agreement of the parties.
                </span>
              </li>
            </ul>

            <p>
              <span style={{ fontWeight: 400 }}> </span>
            </p>

            <p>
              <span style={{ fontWeight: 400 }}>
                If all the above options are unavailable, a court will pick the arbitration company.{' '}
              </span>
              <strong>
                No arbitration brought on a class basis may be administered without our consent by
                any arbitration company that would permit class arbitration under this Agreement.
              </strong>
              <span style={{ fontWeight: 400 }}>
                {' '}
                The TPA will be selected under the arbitration company's rules. However, the TPA
                must be a lawyer with at least ten years of experience or a retired judge unless you
                and we otherwise agree.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Can Claims be brought in court?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Sometimes</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Either party may bring a lawsuit if the other party does not demand arbitration. We
                will not demand arbitration of any lawsuit you bring as an individual action in
                small-claims court. However, we may demand arbitration of any appeal of a
                small-claims decision or any small-claims action brought on a class basis.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Are you giving up any rights?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Yes </strong>
            </p>
          </td>
          <td>
            <p>
              <strong>For Claims subject to this Agreement, you give up your right to:</strong>
            </p>

            <ul>
              <li>
                <strong>Have juries decide Claims.</strong>
              </li>
              <li>
                <strong>Have courts, other than small-claims courts, decide Claims.</strong>
              </li>
              <li>
                <strong>
                  Serve as a private attorney general or in a representative capacity.
                </strong>
              </li>
              <li>
                <strong>
                  Join a Claim you have with a claim by other consumers without our consent.
                </strong>
              </li>
              <li>
                <strong>Bring or participate in a class action or class arbitration.</strong>
              </li>
            </ul>

            <p>
              <strong>
                We also give up the right to a jury trial and to have courts decide Claims you wish
                to arbitrate.
              </strong>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Can you or another consumer start class arbitration?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>No</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>The TPA is </strong>
              <strong>not</strong>
              <strong> allowed to handle any Claim on a class or representative basis. </strong>
              <span style={{ fontWeight: 400 }}>
                All Claims subject to this Agreement must be decided in an{' '}
              </span>
              <strong>individual</strong>
              <span style={{ fontWeight: 400 }}>
                {' '}
                arbitration or an individual small-claims action.{' '}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>What happens if part of this Agreement cannot be enforced? </strong>
            </p>
          </td>
          <td>
            <p>
              <strong>It depends. </strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                If any portion of this Agreement cannot be enforced, the rest of this Agreement will
                continue to apply, except that:{' '}
              </span>
            </p>

            <p>
              <span style={{ fontWeight: 400 }}>
                (A) If a court rules that the TPA can decide a Claim on a class or other
                representative basis and the court's ruling is not reversed on appeal, only this
                sentence will apply and the remainder of this Agreement will be void.{' '}
              </span>
            </p>

            <p>
              <span style={{ fontWeight: 400 }}>
                (B) If a party brings a Claim seeking public injunctive relief and a court
                determines that the restrictions in this Agreement prohibiting the TPA from awarding
                relief on behalf of third parties are unenforceable with respect to such Claim (and
                that determination becomes final after all appeals have been exhausted), the Claim
                for public injunctive relief will be determined in court and any Claims seeking
                monetary relief will be arbitrated on an individual basis. In such a case the
                parties agree to request that the court stay the Claim for public injunctive relief
                until the arbitration award pertaining to monetary relief has been entered in court.
              </span>
            </p>

            <p>
              <strong>
                In no event will a Claim for class relief or public injunctive relief be arbitrated.{' '}
              </strong>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>What law applies?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>The Federal Arbitration Act (the “</strong>
              <strong>FAA</strong>
              <strong>”) </strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                The System Agreements involve interstate commerce. Thus, the FAA governs this
                Agreement. The TPA must apply substantive law consistent with the FAA. The TPA must
                honor statutes of limitation and privilege rights. Punitive damages are governed by
                the constitutional standards that apply in judicial proceedings.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Will anything you do make this Agreement ineffective?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>No, unless you opt out on a timely basis</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                This Agreement stays in force even if you: (1) never sign or cancel one or more
                System Agreements; (2) default, renew, prepay or pay the System Agreements in full;
                or (3) go into or through bankruptcy.{' '}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <p>
              <strong>Process.</strong>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>What must a party do before starting a lawsuit or arbitration?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Send a written Claim notice and work to resolve the Claim</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Before starting a lawsuit or arbitration, the complaining party (the “
              </span>
              <span style={{ fontWeight: 400 }}>Complaining Party</span>
              <span style={{ fontWeight: 400 }}>”) must give the other party (the “</span>
              <span style={{ fontWeight: 400 }}>Defending Party</span>
              <span style={{ fontWeight: 400 }}>
                ”) written notice of the Claim. The notice must explain in reasonable detail the
                nature of the Claim and any supporting facts. If you are the Complaining Party, you
                must send the notice in writing (and not electronically) to us at the Notice
                Address, Attn: Legal Complaint. You or an attorney you have personally hired must
                sign the notice and must provide your full name and a phone number where you (or
                your attorney) can be reached. Once a Claim notice is sent, the Complaining Party
                must give the Defending Party a reasonable opportunity over the next 30 days to
                resolve the Claim on an individual basis.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>How does arbitration start?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Mailing a notice</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                If the parties do not reach an agreement to resolve the Claim within 30 days after
                notice of the Claim is received, the Complaining Party may commence a lawsuit or
                arbitration, subject to the terms of this Agreement. To start arbitration, the
                Complaining Party picks the arbitration company and follows the arbitration
                company's rules. If one party begins or threatens a lawsuit, the other party may
                demand arbitration. This demand may be made in court papers. It may be made if a
                party begins a lawsuit on an individual basis and then tries to pursue a class
                action. Once an arbitration demand is made, no lawsuit may be brought and any
                existing lawsuit must stop.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Will any hearing be held nearby? </strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Yes </strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                The TPA may decide that an in-person hearing is unnecessary and that he or she can
                resolve a Claim based on written filings and/or a conference call. However, any
                in-person arbitration hearing must be held at a place reasonably convenient to you.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>What about appeals?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Very limited </strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Appeal rights under the FAA are very limited. The TPA's decision will be final and
                binding, except for any FAA appeal right. Any appropriate court may enter judgment
                upon the TPA's award.{' '}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <p>
              <strong>Arbitration Fees and Awards.</strong>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Who bears arbitration fees?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>It depends </strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                All filing, administrative, hearing and TPA fees will be borne in accordance with
                the rules of the arbitration administrator, provided that we will bear such fees if
                necessary to enforce this Agreement.{' '}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>When will we cover your legal fees and costs?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>If you win </strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                If you win an arbitration, we will pay your reasonable fees and costs for attorneys,
                experts and witnesses. We will also pay these amounts if required under applicable
                law or the arbitration company's rules or if payment is required to enforce this
                Agreement. The TPA shall not limit his or her award of these amounts because your
                claim is for a small amount.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Will you ever owe us for arbitration or attorneys' fees?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Only for bad faith </strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                The TPA may require you to pay our fees if (and only if): (1) the TPA finds that you
                have acted in bad faith (as measured by the standards set forth in Federal Rule of
                Civil Procedure 11(b)); and (2) such power does not make this Agreement invalid.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>
                Can a failure to resolve a Claim informally result in a larger recovery for you?
              </strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Yes</strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                You are entitled to an arbitration award of at least $7,500 if: (1) you give us
                notice of a Claim on your own behalf (and not on behalf of any other party) and
                comply with all of the requirements of this Agreement (including the requirements
                described in response to the question reading "What must a party do before starting
                a lawsuit or arbitration?"); and (2) the TPA awards you money damages greater than
                the last amount you requested at least ten days before the arbitration commenced.
                This is in addition to the attorneys' fees and expenses (including expert witness
                fees and costs) to which you are otherwise entitled. This $7,500 minimum award is a
                single award that applies to all Claims you have raised or could have raised in the
                arbitration. Multiple awards of $7,500 are not contemplated by this Agreement.
                Settlement demands and offers are strictly confidential. They may not be used in any
                proceeding by either party except to justify a minimum recovery of $7,500.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Can an award be explained?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Yes </strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                A party may request details from the TPA, within 14 days of the ruling. Upon such
                request, the TPA will explain the ruling in writing.
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Do arbitration awards affect other disputes?</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>No </strong>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                No arbitration award involving the parties will have any impact as to issues or
                claims in any dispute involving anyone who is not a party to the arbitration, nor
                will an arbitration award in prior disputes involving other parties have any impact
                in an arbitration between the parties to this Agreement.{' '}
              </span>
            </p>
          </td>
        </tr>
      </tbody>
    </table>

    <p>DMEAST #40973593 v1</p>
  </div>
);

export default ArbitrationAgreement;
